export const uploadSignedUrlMock = async () => {
  return {
    data: {
      signedUrl: 'https://storage.googleapis.com/dynamika7-dev-upload-eu/',
    },
  };
};
